
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#00A2E9"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.523 15.711a3.548 3.548 0 106.766 0l-.013-.039-.001-.04a1.03 1.03 0 011.89-.602l.023.035.013.039a5.555 5.555 0 01-4.354 7.152l.061-.01v3.605a9.109 9.109 0 01-2.004 0 9.002 9.002 0 011.002-17.945 9 9 0 019 9c0 4.3-3.014 7.894-7.045 8.787v-1.99a7.07 7.07 0 10-2.957.203v-1.66c.014.002-3.421-.516-4.362-4.027a5.555 5.555 0 01.07-3.116l.012-.038.022-.035a1.031 1.031 0 011.175-.42c.44.141.734.56.717 1.021l-.002.041-.013.04zm5.121-1.816l1.004-1.738a5.657 5.657 0 00-3.209-.702l-.102.01a5.34 5.34 0 00-2.17.696l1 1.734a3.574 3.574 0 013.477 0zm-1.738.98a2.03 2.03 0 110 4.061 2.03 2.03 0 010-4.06z","fill":"#fff"}})])
          )
        }
      }
    